"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaignQueries = exports.campaignQueryKeys = void 0;
const campaign_api_1 = require("./campaign.api");
exports.campaignQueryKeys = {
    all: () => ['campaign'],
    getFredhopperCampaigns: () => [...exports.campaignQueryKeys.all(), 'fredhopperCampaigns'],
};
const campaignQueries = (apiOptions) => ({
    getFredhopperCampaigns: (locale, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.campaignQueryKeys.getFredhopperCampaigns(), queryFn: () => (0, campaign_api_1.getFredhopperCampaigns)(apiOptions, locale) })),
});
exports.campaignQueries = campaignQueries;
//# sourceMappingURL=campaign.queries.js.map